import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Scrollable } from "../../../Constant";
import CustomScrollbar from "./CustomScrollbar";
import SmallSizeScrollbar from "./SmallSizeScrollbar";
import BadgesScrollbar from "./BadgesScrollbar";
import ScrollableContent from "./ScrollableContent";
import BothSideVisibleScrollbar from "./BothSideVisibleScrollbar";

const ScrollableContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Scrollable} title={Scrollable} parent={BonusUi} />
      <Container fluid>
        <Row>
          <CustomScrollbar />
          <SmallSizeScrollbar/>
          <BadgesScrollbar/>
          <ScrollableContent/>
          <BothSideVisibleScrollbar/>
        </Row>
      </Container>
    </>
  );
};

export default ScrollableContainer;
